<script lang="ts" setup>
export interface FooterGroupProps {
    title: string
}

const props = defineProps<FooterGroupProps>()
</script>
<template>
  <Label
    :label="props.title"
    class="d-none d-md-inline-flex text-uppercase mb-3"
    size="big"
    background-color="var(--global-color-secondary)"
    text-color="var(--global-color-white)"
    aria-hidden="true"
  />
  <span class="fs-bigger d-block d-md-none border-bottom mb-2 pb-1">
    {{ props.title }}
  </span>
  <slot />
</template>
